import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ui_render_failure", { message: error.message, componentStack: info.componentStack });
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-error-page">
          <section className="fatal-error-card">
            <p className="eyebrow">DISPLAY ERROR</p>
            <h1>畫面顯示發生錯誤</h1>
            <p>資料可能已完成處理，但回傳格式無法正常顯示。請重新整理頁面；若再次發生，請停止重試並回報管理者。</p>
            <button className="primary-button" type="button" onClick={() => window.location.reload()}>重新整理</button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
